import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { TitlePage } from 'entities/page';
import { selectSessionSlice } from 'entities/session';
import { LoginForm } from 'features/authentication/login';
import { Header } from 'features/page';
import { ROUTES } from 'shared/constant/routes';
import { useAppSelector } from 'shared/model';

export const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthorized } = useAppSelector(selectSessionSlice);

  const onComplete = () => {
    navigate(ROUTES.APP);
  };

  useEffect(() => {
    if (isAuthorized && location.pathname === ROUTES.LOGIN) {
      navigate(ROUTES.APP);
    }
  }, [location, isAuthorized, navigate]);

  return (
    <>
      <TitlePage title="loginText" />
      <Header hideMenu />
      <LoginForm onComplete={onComplete} />
    </>
  );
};
